import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actionCreators } from '@/checkout-instore-legacy/cart/actions'
import { addRecentTerm } from '@/checkout-instore-legacy/search/actions'
import { actionCreators as productActionCreators } from '@/checkout-instore-legacy/product/actions'
import { actionCreators as cartSimulationActionCreators } from '@/checkout-instore-legacy/cart/simulation/actions'

import SearchResult from './SearchResult'

const mapStateToProps = (state) => {
  const { currencyCode } = state.order.orderForm
    ? state.order.orderForm.storePreferencesData
    : { currencyCode: 'BRL' }
  return {
    currencyCode,
    term: state.search.term,
    stock: state.product.stock,
    isLoadingStock: state.product.isLoadingStock,
    isSimulationLoading: state.cartSimulation.isSimulationLoading,
    searchSimulationLoading: state.search.searchSimulationLoading,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionCreators,
      ...productActionCreators,
      addRecentTerm,
      ...cartSimulationActionCreators,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(SearchResult)
